<!-- 扣减月票余额 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "dataList": [
                    {
                        "carNo": "黑FFFF22",
                        "parkingCode": "23082411005292030129522",
                        "deductValue": 2,
                        "discountValue": 2,
                        "shouldPayValue": 6.06,
                        "enterTime": "20230824110101",
                        "deductTime": "20230829160659",
                        "monthTicketBillId": 13392,
                        "billCode": "2023082916023164019277",
                        "parkCode": "2KPJZECG"
                    }
                ]
            },
            responseCode: {
                "data": {
                },
                "message": "业务成功",
                "resultCode": 0,
                "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台 扣减月票余额",
                t_url: this.commonUrls.test+"deductMonthTicketBalance",
                p_url: this.commonUrls.prod+"deductMonthTicketBalance",
                precondition: "无",
                fitSystem: "VEMS传统停车场, 云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                          { info1: 'dataList', info2: '是', info3: 'JSONArray', info4: '月票余额扣减列表' },
                        ]
                },{
                    titleName: "dataList",
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                          { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编码' },
                          { info1: 'monthTicketBillId', info2: '是', info3: 'Long', info4: '月票ID' },
                          { info1: 'carNo', info2: '是', info3: 'String', info4: '车牌号码' },
                          { info1: 'carNoColor', info2: '否', info3: 'Integer', info4: '车牌号码颜色，暂未使用，<url>参考附录:/Api/appendixData#appendixData_7</url>' },
                          { info1: 'parkingCode', info2: '是', info3: 'String', info4: '停车记录编号' },
                          { info1: 'billCode', info2: '是', info3: 'String', info4: '扣减订单号，在调payParkFee接口时带回' },
                          { info1: 'deductValue', info2: '是', info3: 'Decimal', info4: '扣减值，' },
                          { info1: 'discountValue', info2: '是', info3: 'Decimal', info4: '优惠金额，单位：元' },
                          { info1: 'shouldPayValue', info2: '是', info3: 'Decimal', info4: '应缴金额，单位：元' },
                          { info1: 'enterTime', info2: '是', info3: 'String', info4: '进场时间：yyyyMMddHHmmss' },
                          { info1: 'deductTime', info2: '是', info3: 'String', info4: '扣减时间：yyyyMMddHHmmss' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/ticket/operation/deductMonthTicketBalance.vue